import type { InputProps } from '@chakra-ui/react'
import { forwardRef, Input } from '@chakra-ui/react'
import { format, parse } from 'BrokerTsLib/src/Utils/formatInputs'
import { Controller, useFormContext } from 'BrokerTsLib/src/rhf'
import { numericFormatter } from 'react-number-format'

export interface NumberInputProps extends InputProps {
  name: string
}

export interface NumberInputControllerProps { }

const NumberInputController = forwardRef(
  ({ control, transform, name, defaultValue, isDisabled, onKeyUp, ...rest }: any, ref) => {
    return (
      <Controller
        defaultValue={defaultValue}
        control={control}
        name={name}
        render={({ field }) => (
          <Input
            {...field}
            ref={ref}
            isDisabled={isDisabled}
            onChange={(e) => field.onChange(transform.output(e))}
            value={transform.input(field.value)}
            onKeyUp={onKeyUp}
          />
        )}
      />
    )
  },
)

export const NumberInput = forwardRef(({ ...props }: NumberInputProps, ref) => {
  const { control } = useFormContext()

  return (
    <NumberInputController
      ref={ref}
      transform={{
        input: (value: string | number | null | undefined) => {
          if (typeof value === 'undefined' || value === null) return ''

          if (typeof value === 'number') return format(value.toString())

          const newValue = numericFormatter(value, {
            thousandSeparator: ' ',
            decimalSeparator: ',',
          })

          return newValue
        },
        output: (e: any) => parse(e.target.value),
      }}
      control={control}
      {...props}
    />
  )
})
